import { render } from "./HeaderInfo.vue?vue&type=template&id=6207c810"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"

import "./HeaderInfo.vue?vue&type=style&index=0&id=6207c810&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__